/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_01_NumInputs */

const en_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const de_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const fr_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const es_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const it_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const nl_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const pl_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const fi_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const da_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

const sv_landing_section_01_num = /** @type {(inputs: Landing_Section_01_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01`)
};

/**
* | output |
* | --- |
* | "01" |
*
* @param {Landing_Section_01_NumInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_01_num = /** @type {((inputs?: Landing_Section_01_NumInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_01_NumInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_01_num(inputs)
	if (locale === "fr") return fr_landing_section_01_num(inputs)
	if (locale === "es") return es_landing_section_01_num(inputs)
	if (locale === "it") return it_landing_section_01_num(inputs)
	if (locale === "nl") return nl_landing_section_01_num(inputs)
	if (locale === "pl") return pl_landing_section_01_num(inputs)
	if (locale === "fi") return fi_landing_section_01_num(inputs)
	if (locale === "da") return da_landing_section_01_num(inputs)
	if (locale === "sv") return sv_landing_section_01_num(inputs)
	return en_landing_section_01_num(inputs)
});